<template>
  <container-component>
    <form-table style="padding: 0;">
      <template #table>
        <v-data-table
            ref="table"
            :headers="colunas"
            :items="itens"
            :server-items-length="totalItens"
            :options.sync="paginacaoInterna"
            :loading="false"
            no-data-text="Não há atendimentos registrados..."
            class="table-list"
            hide-default-footer
            disable-sort
            @click:row="tratarEventoAcessar">
          <template v-slot:item.codigo="{item}">
            <span>{{ item.codigo | textoSemValor }}</span>
          </template>
          <template v-slot:item.status="{item}">
            <status-atendimento-icone :status-nome="item.status" :status-api="item.statusApi"/>
          </template>
          <template v-slot:item.dataHora="{item}">
            <span>{{ item.dataInicio | filterDataHora }}</span>
          </template>
          <template v-slot:item.dentistaNome="{item}">
            <div class="d-flex align-center">
              <div class="mr-1">
                <foto-avatar :foto-url="item.dentistaFoto" class-avatar="imagem-dentista"/>
              </div>
              <v-badge location="top right" color="success" dot v-if="atendimentoNovo === item.id">
                <span class="max-label">{{ item.dentistaNome | textoSemValor }}</span>
              </v-badge>
              <span class="max-label" v-else>{{ item.dentistaNome | textoSemValor }}</span>
            </div>
          </template>
          <template v-slot:item.acoes>
            <v-icon>mdi-chevron-right</v-icon>
            <span class="mobile">Ver</span>
          </template>
        </v-data-table>
      </template>
      <template #footer>
        <div class="pagination">
          <v-pagination
              v-if="paginas > 1"
              v-model="paginacaoInterna.page"
              total-visible="7"
              :length="paginas"
          />
        </div>
      </template>
    </form-table>
  </container-component>
</template>

<script>
import mutationTypes from '@/core/constants/mutationTypes'
import FormTable from '@/views/components/FormTable.vue'
import ContainerComponent from '@/views/components/Container.vue'
import StatusAtendimentoIcone from '@/views/components/StatusAtendimentoIcone.vue'
import FotoAvatar from '@/views/components/FotoAvatar.vue'

export default {
    name: 'OdontogramaAtendimentoTabela',
    components: {FotoAvatar, StatusAtendimentoIcone, ContainerComponent, FormTable},
    props: ['itens', 'paginacao', 'paginas', 'totalItens', 'atendimentoNovo'],
    data() {
        return {
            colunas: [
                {
                    text: 'Código',
                    value: 'codigo',
                    sortable: false,
                    align: 'left',
                    width: '20px',
                    class: 'gray--text'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'left',
                    width: '20px',
                    class: 'gray--text'
                },
                {
                    text: 'Data/Hora',
                    value: 'dataHora',
                    sortable: false,
                    align: 'left',
                    width: '130px',
                    class: 'gray--text'
                },
                {
                    text: 'Dentista',
                    value: 'dentistaNome',
                    sortable: false,
                    align: 'left',
                    width: '160px',
                    class: 'gray--text'
                },
                {
                    text: '',
                    value: 'acoes',
                    sortable: false,
                    align: 'right',
                    width: '30px',
                    class: 'gray--text'
                }
            ],
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
        }
    },
    methods: {
        tratarEventoAcessar(item) {
            this.$emit('acessar', item.id)
        },
        resetaPage() {
            this.$store.commit(mutationTypes.ATENDIMENTO.RESETA_PAGE)
        },
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true,
        },
    },
}
</script>

<style scoped lang="stylus">

.imagem-dentista
  width 40px
  height 40px
  border-radius 50%
  border 2px solid #eee

.max-label
  display inline-block
  max-width 150px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.table-list
  min-height 300px

  table
  >>> thead > tr > th
    padding 0 5px !important

  >>> tbody > tr > td
    padding 0 5px !important

</style>
